import { ErrorMessageConstants } from '../constants/error-message-constants';
import { NumberConstants } from '../constants/number-constants';

export class AppValidator {
  static readonly firstNamePattern = /^[a-zA-Z][a-zA-Z0-9]{0,20}$/;

  ///Space allowed in last name
  static readonly lastNamePattern = /^[a-zA-Z][a-zA-Z0-9 ]{0,20}$/;
  public static validatePassword(value: string): string | undefined {
    let error =
      this.setPasswordError(
        /[A-Z]/.test(value),
        ErrorMessageConstants.PASSWORD_UPPER_CASE_ERROR
      ) ??
      this.setPasswordError(
        /[a-z]/.test(value),
        ErrorMessageConstants.PASSWORD_LOWER_CASE_ERROR
      ) ??
      this.setPasswordError(
        /\d/.test(value),
        ErrorMessageConstants.PASSWORD_NUMBER_ERROR
      ) ??
      this.setPasswordError(
        /[@#&%*!~$^_]/.test(value),
        ErrorMessageConstants.PASSWORD_SPECIAL_CHAR_MUST_ERROR
      ) ??
      this.setPasswordError(
        value.length >= NumberConstants.PASSWORD_MIN_LENGTH,
        ErrorMessageConstants.PASSWORD_MIN_LENGTH_ERROR
      ) ??
      this.setPasswordError(
        value.length <= NumberConstants.PASSWORD_MAX_LENGTH,
        ErrorMessageConstants.PASSWORD_MAX_LENGTH_ERROR
      );
    if (error == undefined) {
      const pass = value
        .replace(/[A-Z]/g, '')
        .replace(/[a-z]/g, '')
        .replace(/\d/g, '')
        .replace(/[@#&%*!~$^_]/g, '');
      error = this.setPasswordError(
        pass == '',
        ErrorMessageConstants.PASSWORD_SPECIAL_CHAR_MUST_NOT_ERROR
      );
    }
    return error;
  }

  private static setPasswordError(
    isValid: boolean,
    error: string
  ): string | undefined {
    if (!isValid) {
      return error;
    }
    return undefined;
  }

  public static validateFirstName(name: string): string | undefined {
    if (name.includes(' ')) {
      return ErrorMessageConstants.FIRST_LAST_NAME_SPACE_ERROR;
    }
    if (name.trim().length == 0) {
      return ErrorMessageConstants.ENTER_FIRST_NAME;
    }
    if (name.trim().length < NumberConstants.FIRST_NAME_MIN_LENGTH) {
      return ErrorMessageConstants.FIRST_LAST_NAME_MIN_LENGTH;
    }
    if (name.trim().length > NumberConstants.FIRST_NAME_MAX_LENGTH) {
      return ErrorMessageConstants.FIRST_NAME_MAX_LENGTH;
    }
    if (/[$=\\|<>^*%]/.test(name)) {
      return ErrorMessageConstants.FIRST_LAST_NAME_SPECIAL_CHAR_ERROR;
    }
    if (!this.firstNamePattern.test(name)) {
      return ErrorMessageConstants.INVALID_FIRST_NAME;
    }
    return undefined;
  }

  public static validateLastName(name: string) {
    if (name.startsWith(' ') || name.endsWith(' ')) {
      return ErrorMessageConstants.INVALID_LAST_NAME;
    }
    if (name.trim().length == 0) {
      return ErrorMessageConstants.ENTER_LAST_NAME;
    }
    if (name.trim().length < NumberConstants.LAST_NAME_MIN_LENGTH) {
      return ErrorMessageConstants.FIRST_LAST_NAME_MIN_LENGTH;
    }
    if (name.trim().length > NumberConstants.LAST_NAME_MAX_LENGTH) {
      return ErrorMessageConstants.LAST_NAME_MAX_LENGTH;
    }
    if (/[$=\\|<>^*%]/.test(name)) {
      return ErrorMessageConstants.FIRST_LAST_NAME_SPECIAL_CHAR_ERROR;
    }
    if (!this.lastNamePattern.test(name)) {
      return ErrorMessageConstants.INVALID_LAST_NAME;
    }
    return undefined;
  }
}
